import React from "react";
import PropTypes from "prop-types";
import { GlobalStyles } from "twin.macro";
import "./styles.css";
import {
  Container
} from './styles';

const Layout = ({ children }) => {
  return (
    <Container>
      <GlobalStyles />
      {children}
    </Container>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
